import { html, repeat } from '@genesislcap/web-core';
import { persistLayout } from '../../../../mbm/utils';
import type { UserActivityRoute } from './user-activity';
import { getUserLoginAuditColumns } from './user-activity.columns';
import {ColDef} from '@ag-grid-community/core';

export const UserActivityTemplate = html<UserActivityRoute>`
  <rapid-layout auto-save-key="${() => persistLayout('User Activity_1756193853393')}">
    <rapid-layout-region type="tabs">
      <rapid-layout-item title="User Management">
        <rapid-grid-pro 
          enable-row-flashing 
          enable-cell-flashing
          enable-range-selection
        >
          <grid-pro-genesis-datasource
            resource-name="USER_VIEW"
            polling-interval="30000"
            :deferredGridOptions=${(x) => x.userManagementGridOptions}
          ></grid-pro-genesis-datasource>
        </rapid-grid-pro>
      </rapid-layout-item>
      
      <rapid-layout-item title="User Login Audit">
        <rapid-grid-pro 
          enable-row-flashing 
          enable-cell-flashing
          enable-range-selection
          only-template-col-defs
        >
          ${repeat(
            () => getUserLoginAuditColumns(),
            html<ColDef>`
              <grid-pro-column :definition="${(x) => x}"></grid-pro-column>
            `
          )}
          <grid-pro-server-side-datasource
            resource-name="LOGIN_AUDIT"
            max-rows="250"
          ></grid-pro-server-side-datasource>
        </rapid-grid-pro>
      </rapid-layout-item>
      
      <rapid-layout-item title="Active Sessions">
        <rapid-grid-pro 
          enable-row-flashing 
          enable-cell-flashing
          enable-range-selection
        >
          <grid-pro-genesis-datasource
            resource-name="USER_SESSION_VIEW"
            polling-interval="30000"
            :deferredGridOptions=${(x) => x.userSessionGridOptions}
          ></grid-pro-genesis-datasource>
        </rapid-grid-pro>
      </rapid-layout-item>
    </rapid-layout-region>
  </rapid-layout>
`;

